import { FileOutput } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import ToolPage from "./ToolPage";

export default function WordtoPDF() {
  const { t } = useLanguage();
  const tk = t.tools.wordToPdf;


  const config = {
    title: tk.title,
    description: tk.description,
    action: tk.action,
    hint: tk.dropHint,
    hintSub: tk.dropHintSub,
    endpoint: "/pdf/word-to-pdf",
    accept: ".docx,.doc",
    multiple: false,
    resultType: "download",
    resultFileName: tk.result,
    color: "#ea580c",
    Icon: FileOutput,
    toolKey: "wordToPdf",
  };

  return <ToolPage config={config} />;
}
